import React, {useCallback} from 'react';

import {MaxRunsWarningBanner} from '../../../../MaxRuns/MaxRunsWarningBanner';
import {MAX_RUNS_PERF_WARNING_THRESHOLD} from '../../../../PanelMediaBrowser/config';
import {
  useMediaMaxRunsDisplay,
  useShouldShowMediaMaxRunsResetAtLevel,
} from '../../hooks';
import {DEFAULT_PANEL_MAX_NUM_RUNS} from '../../runLinePlots/maxRunDefaults';
import {SettingsSliderInput} from '../common/SettingsSliderInput';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsContext} from '../contexts/MediaSettingsContextProvider';

export const MaxRuns = () => {
  const {updateConfig, unsetConfigField, settingsLevel, panelRef} =
    useMediaSettingsContext();
  const initialValue = useMediaMaxRunsDisplay(settingsLevel, panelRef);
  const isSetAtLevel = useShouldShowMediaMaxRunsResetAtLevel(
    settingsLevel,
    panelRef
  );

  // Debounce the updateConfig call so we don't update on every keystroke or slider change
  const updateConfigCallback = useCallback(
    (value: number) => {
      updateConfig({maxRuns: value});
    },
    [updateConfig]
  );

  return (
    <div className="flex flex-col">
      <SettingTitle
        title="Max runs to include"
        id="max-runs-label"
        configField="maxRuns"
        isDirty={isSetAtLevel}
        unsetConfigField={() => unsetConfigField('maxRuns')}
      />
      <SettingsSliderInput
        initialValue={initialValue}
        updateConfigCallback={updateConfigCallback}
        min={1}
        max={DEFAULT_PANEL_MAX_NUM_RUNS}
        data-test="max-runs-slider-input"
        aria-labelledby="max-runs-label"
      />
      {initialValue >= MAX_RUNS_PERF_WARNING_THRESHOLD && (
        <MaxRunsWarningBanner
          numRuns={initialValue}
          location="workspace-media"
        />
      )}
    </div>
  );
};
